import { makeStyles } from "@material-ui/core";

export const vinDecoderStyle = makeStyles((theme) => ({
    button: {
        height: '3.5em'
    }
}));